export default __webpack_public_path__ + "static/media/IMG_5310-2 - ABHISHEK KUMAR.8f6d0185.jpg";